import styled from 'styled-components'
import { Label } from '@/components/form'
import { colors, fontWeights } from '@/styles'
export { StyledPanel, StyledRow, StyledLabel } from '@/features/Payments/forms/elements'

export const StyledValue = styled(Label)`
  font-weight: ${fontWeights.medium};
  flex: 1;
  text-align: right;
`

export const FeeInfoWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 5px;
    margin-bottom: -2px;
    cursor: pointer;
  }
`

export const Link = styled.a`
  color: ${colors.link};
  text-decoration: underline;

  :hover {
    opacity: 0.8;
  }
`
